import EditingPausedBanner from "common/EditingPausedBanner";
import bem from "easy-bem";
import MenuHeader from "features/menu/blocks/MenuHeader";
import { usePages } from "features/pages/usePages";
import { resolveNativeMenuOverride } from "features/pages/utils";
import { useFlag } from "hooks/useFlags";
import { useIsMobile } from "hooks/useIsMobile";
import React from "react";
import { useLocation } from "react-router-dom";

import Footer from "./footer";
import Header from "./header";
import "./PageLayout.css";

const cn = bem("page-layout");

type PageLayoutProps = {
  withHeader?: boolean;
  withFooter?: boolean;
  limitedWidth?: boolean;
  hideFooterBackLink?: boolean;
  children: React.ReactNode;
};

const PageLayout: React.FC<PageLayoutProps> = ({
  withHeader = true,
  withFooter = true,
  limitedWidth = true,
  hideFooterBackLink = false,
  children,
}) => {
  const { isMobile } = useIsMobile();
  const menuHeaderEnabled = useFlag("menuHeaderTest");
  const contentEditingPaused = useFlag("contentEditingPaused");
  const maintenanceModeEnabled = useFlag("maintenanceModeEnabled");
  const { pathname } = useLocation();
  const pages = usePages();
  const menuSlug =
    resolveNativeMenuOverride(pathname, pages ?? []) ?? "platform";

  return (
    <div className={cn({ limitedWidth, mobile: isMobile })}>
      {(contentEditingPaused || maintenanceModeEnabled) && (
        <EditingPausedBanner />
      )}
      {withHeader &&
        (menuHeaderEnabled ? <MenuHeader menuSlug={menuSlug} /> : <Header />)}
      <div className={cn("content", { limitedWidth })}>{children}</div>
      {withFooter && <Footer hideBackLink={hideFooterBackLink} />}
    </div>
  );
};

export default PageLayout;
